export const Error = "Error";
export const GetAllAccountType = "GetAllAccountType";
export const GetOneAccountType = "GetOneAccountType";
export const GetAllMainAccount = "GetAllMainAccount";
export const GetOneMainAccount = "GetOneMainAccount";
export const DeleteOneMainAccount = "DeleteOneMainAccount";
export const InsertOneMainAccount = "InsertOneMainAccount";
export const UpdateOneMainAccount = "UpdateOneMainAccount";
export const GetAllMainAccountByAccounttype = "GetAllMainAccountByAccounttype";
export const CREATE_NEW_USER = "CREATE_NEW_USER";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const VERIFY_PASSWORD = "VERIFY_PASSWORD";
export const FOREGT_PASSWORD = "FOREGT_PASSWORD";
export const LOGIN_USER = "LOGIN_USER";
export const GET_CURERNT_USER = "GET_CURERNT_USER";
export const UPDATE_USER_PROFILE = "UPDATE_USER_PROFILE";
export const UPDATE_USER_PASSWORD = "UPDATE_USER_PASSWORD";
export const GetAllFiles = "GetAllFiles";
export const GetOneFile = "GetOneFile";
export const DeleteOneFile = "DeleteOneFile";
export const InsertOneFile = "InsertOneFile";
export const UpdateOneFile = "UpdateOneFile";
export const GetAllFilesDetails = "GetAllFilesDetails";
export const GetOneFileDetails = "GetOneFileDetails";
export const DeleteOneFileDetails = "DeleteOneFileDetails";
export const InsertOneFileDetails = "InsertOneFileDetails";
export const UpdateOneFileDetails = "UpdateOneFileDetails";
export const GetOneSupAccountWithMain = "GetOneSupAccountWithMain";
export const DeleteOneSupAccount = "DeleteOneSupAccount";
export const InsertOneSupAccount = "InsertOneSupAccount";
export const UpdateOneSupAccount = "UpdateOneSupAccount";
export const GetAllSubuserAccount = "GetAllSubuserAccount";
export const GetOneSubuserAccount = "GetOneSubuserAccount";
export const DeleteSubuserAccount = "DeleteSubuserAccount";
export const InsertOneSubuserAccount = "InsertOneSubuserAccount";
export const UpdateOneSubuserAccount = "UpdateOneSubuserAccount";
export const GetSubUsersFiles = "GetSubUsersFiles";
export const Insertusersubdash = "Insertusersubdash";
export const Getusersubdash = "Getusersubdash";
export const Insertusersubdashside = "Insertusersubdashside";
export const Getusersubside = "Getusersubside";
export const Insertemailtry = "Insertemailtry";
export const UpdateUserdashboard = "UpdateUserdashboard";
export const UpdateUserAndsubdashboard = "UpdateUserAndsubdashboard";
export const DeleteUserdashboard = "DeleteUserdashboard";
export const GetAllFilesDetailsmulit = "GetAllFilesDetailsmulit";
export const GetAllMainfileAccount = "GetAllMainfileAccount";
export const getFilesubuser = "getFilesubuser";
export const CreateContact = "CreateContact";
export const UpdateQoute = "UpdateQoute";
export const GetQoutsdashh = "GetQoutsdashh";
export const GetQoutssidee = "GetQoutssidee";
export const senEmailtouser = "senEmailtouser";
export const getUserAndSubuser = "getUserAndSubuser";
export const getUserSubscriber = "getUserSubscriber";
export const getFilesDetailsLast = "getFilesDetailsLast";
export const Updateuserdashside = "Updateuserdashside";
export const CreatedashNotification = "CreatedashNotification";
export const getuserNotification = "getuserNotification";
export const DeleteUsersubscripedashboard = "DeleteUsersubscripedashboard";
export const Updatesqouteuserr = "Updatesqouteuserr";
export const notnumber = "notnumber";

//admin
export const GetRoles = "GetRoles";
export const GetClaims = "GetClaims";
export const CreateUserDashboard = "CreateUserDashboard";
export const ManageUserClaims = "ManageUserClaims";
export const GetUsers = "GetUsers";
//hr
export const ADD_Department = "ADD_Department";
export const UPDATE_Department = "UPDATE_Department";
export const DELETE_Department = "DELETE_Department";
export const GET_Department = "GET_Department";

export const ADD_Employee = "ADD_Employee";
export const UPDATE_Employee = "UPDATE_Employee";
export const DELETE_Employee = "DELETE_Employee";
export const GET_Employee = "GET_Employee";

export const ADD_JopTitle = "ADD_JopTitle";
export const UPDATE_JopTitle = "UPDATE_JopTitle";
export const DELETE_JopTitle = "DELETE_JopTitle";
export const GET_JopTitle = "GET_JopTitle";

export const ADD_Holiday = "ADD_Holiday";
export const UPDATE_Holiday = "UPDATE_Holiday";
export const DELETE_Holiday = "DELETE_Holiday";
export const GET_Holiday = "GET_Holiday";

export const ADD_ATTENDENCE = "ADD_ATTENDENCE";
export const UPDATE_ATTENDENCE = "UPDATE_ATTENDENCE";
export const DELETE_ATTENDENCE = "DELETE_ATTENDENCE";
export const GET_ATTENDENCE = "GET_ATTENDENCE";

export const ADD_ADMIN_REQUEST = "ADD_ADMIN_REQUEST";
export const UPDATE_ADMIN_REQUEST = "UPDATE_ADMIN_REQUEST";
export const DELETE_ADMIN_REQUEST = "DELETE_ADMIN_REQUEST";
export const GET_ADMIN_REQUEST = "GET_ADMIN_REQUEST";
export const GET_REMAINING_ADMIN_REQUEST = "GET_REMAINING_ADMIN_REQUEST";

export const ADD_SALARY = "ADD_SALARY";
export const UPDATE_SALARY = "UPDATE_SALARY";
export const DELETE_SALARY = "DELETE_SALARY";
export const GET_SALARY = "GET_SALARY";

export const ADD_ATTEND_EMP = "ADD_ATTEND_EMP";
export const ADD_REQUEEST_EMP = "ADD_REQUEEST_EMP";
export const GET_ATTEND_EMP = "GET_ATTEND_EMP";
export const GET_REQUEST_EMP = "GET_REQUEST_EMP";

export const Create_CONTACT = "Create_CONTACT";
